module.exports = __webpack_public_path__ + "0a46d05710fe4f3fa5b6aab1e4ee3580.png";